import { IconButton, SvgLink, Tooltip } from '@loomhq/lens';
import React, { useRef, useState } from 'react';

import { SHARE_CTA_ACTION_LINK } from 'constants/events';
import * as analytics from 'utilities/analytics';
import * as clipboard from 'utilities/clipboard';
import {
  getAliasVideoUrl,
  getShareVideoUrl,
  isAliasVideoUrl,
} from 'utilities/video';

const TOOLTIP_STATE = {
  DEFAULT: 'Copy Link',
  LINK_COPIED: 'Link copied!',
};

export function getLink(videoId) {
  if (isAliasVideoUrl(window.location.pathname)) {
    const [, aliasId] = location.pathname.match(/\/a\/([a-z0-9]{32})*/);

    if (aliasId) {
      return getAliasVideoUrl(aliasId);
    }
  }

  return getShareVideoUrl({ id: videoId });
}

export default function CopyLinkIconButton({ videoId, ...props }) {
  const url = getLink(videoId);
  const inputRef = useRef();
  const [tooltipContent, setTooltipContent] = useState(TOOLTIP_STATE.DEFAULT);

  function onCopy() {
    clipboard.copy(inputRef.current);
    setTooltipContent(TOOLTIP_STATE.LINK_COPIED);
    setTimeout(() => {
      setTooltipContent(TOOLTIP_STATE.DEFAULT);
    }, 2000);
    analytics.track(SHARE_CTA_ACTION_LINK, { video_id: videoId });
  }

  return (
    <>
      <input className="none" ref={inputRef} readOnly value={url} />
      <Tooltip content={tooltipContent} placement="bottomLeft">
        <IconButton
          altText="Copy link"
          icon={<SvgLink />}
          onClick={onCopy}
          {...props}
        />
      </Tooltip>
    </>
  );
}
